import React, { Component, PropTypes } from 'react';
import { Meta } from 'common/components/meta';
import Step2Client from 'registration/client/containers/step2';
import Step2Creative from 'registration/creative/containers/step2';

class Step2 extends Component {
  render() {
    const { user } = this.props;

    return (
      <div>
        <Meta title="Registration" />
        { user.profile_data.is_creative? <Step2Creative /> : <Step2Client /> }
      </div>
    );
  }
}

Step2.propTypes = {
  user: PropTypes.object
}

export default Step2;



// WEBPACK FOOTER //
// ./registration/common/components/step2.jsx